import React, { ReactNode } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar as MaterialAvatar } from "@material-ui/core";
import clsx from "clsx";
import { colors } from "../../theme";

interface Props {
  children: ReactNode;
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: colors.AVATAR_LETTER_BG,
  },
}));

export default function Avatar({ children, className }: Props) {
  const classes = useStyles();

  return (
    <MaterialAvatar className={clsx(classes.avatar, className)}>
      {children}
    </MaterialAvatar>
  );
}

/* With photo: <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg"  />
 */
